import classNames from 'classnames';

import { IcEdit16Icon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { Button } from '@gem/ui-kit';

import usePresenter from './presenter';
import styles from './styles.m.scss';

const ArticleDraftsButton = ({ groupId, className }) => {
  const { t } = useTranslation();
  const presenter = usePresenter({ groupId });

  return (
    <Button
      className={classNames(styles.container, className)}
      onClick={presenter.onClick}
      Icon={IcEdit16Icon}
      theme="text-secondary"
    >
      <div className={styles.title}>{t('channel_article_drafts')}</div>
    </Button>
  );
};

export default ArticleDraftsButton;
